document.addEventListener('DOMContentLoaded', function () {
  // Check if any element with the class "swatch-color-js" exists
  var elms = document.querySelectorAll('.product-variant-option[name="Color"]');
  if (elms.length > 0) {
    var elm = document.querySelector('.product-variant-option[name="Color"]:checked');
    var color = elm.getAttribute('value');

    var selectedSwatchText = document.getElementById('selected-swatch-text');
    if (selectedSwatchText) {
      selectedSwatchText.textContent = color;
    }

    // Attach a click event listener to the document, and filter for clicks on elements with the class "swatch-color-js"
    document.addEventListener('click', function (event) {
      var target = event.target;
      if (target.classList.contains('product-variant-option')) {
        var elm = document.querySelector('.product-variant-option[name="Color"]:checked');
        var color = elm.getAttribute('value');

        var selectedSwatchText = document.getElementById('selected-swatch-text');
        if (selectedSwatchText) {
          selectedSwatchText.textContent = color;
        }
      }
    });
  }

  document.addEventListener('click', function (event) {
    var target = event.target;

    // Sort by swap active
    if (target.classList.contains('facet-filters-sort-js')) {
      const elements = document.getElementsByClassName('facet-filters-sort-js');
      const elementsArray = Array.from(elements);
      if (elementsArray.length > 0) {
        elementsArray.forEach((element) => {
          element.classList.remove('active');
        });
      }

      target.classList.add('active');
    }

    // close announcement bar
    if (target.classList.contains('close-announcement-bar')) {
      localStorage.setItem('closeAnnouncementBar', 'true');
      localStorage.setItem('updatedAt', new Date());

      const element = document.getElementById('announcement-bar');
      if (element) {
        element.classList.add('hidden');
      }
    }
  });

  if (localStorage.getItem('updatedAt')) {
    const dateToCheck = localStorage.getItem('updatedAt');
    const result = isMoreThan10DaysAgo(dateToCheck);

    if (result) {
      localStorage.setItem('closeAnnouncementBar', null);
      localStorage.setItem('updatedAt', null);
    }
  }

  if (localStorage.getItem('closeAnnouncementBar') != 'true') {
    const element = document.getElementById('announcement-bar');
    if (element) {
      element.classList.remove('hidden');
    }
  }
});

// Function to check if a date is more than 10 days ago
function isMoreThan10DaysAgo(dateToCheck) {
  // Get the current date
  const currentDate = new Date();

  // Calculate the date 10 days ago
  const tenDaysAgo = new Date();
  tenDaysAgo.setDate(currentDate.getDate() - 10);

  // Convert the dateToCheck into a Date object if it's not already
  const checkDate = new Date(dateToCheck);

  // Compare checkDate with tenDaysAgo
  return checkDate < tenDaysAgo;
}
